import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApiAuthService } from '../../../services/api-auth.service';
import { Proveedor } from 'src/app/models/Proveedor';
import { isNullOrUndefined } from 'util';
import { ApiDownloadFileService } from '../../../services/api-download-file.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public lock: boolean = false;

  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(private router: Router, private apiAuth: ApiAuthService,private apiDownload: ApiDownloadFileService) {
   }

  ngOnInit() {
  }

  revisaLogin() {
    /*Si el proveedor esta logueado accede a proced-proveedor, sino solo procedimientos. */
    let rutaProc: string = '/procedimientos';
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    return rutaProc;
  }

  //Descargar del Manual
  descargaManual() {
    window.open('/assets/pdf/AD-CR-IT-01 Manual de Operación de Plataforma Adquisiciones y Obra Pública.pdf', '_blank');
  }

  //Descargar del Manual
  descargaManualPrest() {
    window.open('/assets/pdf/AD-CR-IT-03 Manual de Registro.pdf', '_blank');
  }
}
